export const MOBILE_WIDTH = '1200px';

export const DESKTOP_WIDTH = '1201px';

export const PRINTOS_HEIGHT = '80px';

export const LEFT_MENU__EXTENDED = '260px';
export const LEFT_MENU__COLLAPSED = '0px';
